import * as React from 'react';
import ChevronDown from 'components/src/svg/ChevronDown';
import Button from 'components/src/button';
import clsx from 'clsx';

type Props = {
  title: string;
  showMobileMenu?: boolean;
  isSelected: boolean;
  hasChevron?: boolean;
  transparent?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const NavbarLabel = ({
  title,
  showMobileMenu = false,
  isSelected,
  hasChevron = false,
  transparent = false,
  onClick,
}: Props) => {
  return (
    <Button
      icon={hasChevron ? <ChevronDown stroke={transparent ? '#FEF4F5' : '#181818'} /> : undefined}
      iconPosition="right"
      onClick={onClick}
      label={title}
      variant={isSelected ? 'primary' : transparent ? 'inverted' : 'surface'}
      classes={clsx('flex h-auto items-center px-xl', {
        'w-full flex-1 !justify-start gap-sm self-stretch py-[18px]': showMobileMenu,
        'mx-2 justify-center py-[12px] align-middle': !showMobileMenu,
        'text-[#FEF4F5]': isSelected,
      })}
      labelClasses={`${showMobileMenu ? '' : 'items-center justify-center '}text-red-100 flex align-middle`}
    />
  );
};

export default NavbarLabel;
